import { ajax, ajaxWithoutAuth, ajaxMiddleWithoutAuth, ajaxJSON } from './ajax';
import { API_DOMAIN, MIDDLE_INTEGRATION_API, ADMIN_DOMAIN } from '../utils/constants';

/** 登录模块 */

export const ckeditorConfig = {
    heading: {
        options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
            // { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
            // { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
        ]
    },
    ckfinder: {
        uploadUrl: API_DOMAIN + '/api/v1/ckUpload'
    }
};

// export const InstallAppUrl = 'https://apps.shopify.com/seo-master-1?surface_detail=seo&surface_inter_position=2&surface_intra_position=9&surface_type=search';  // 安装app界面
export const InstallAppUrl = 'https://apps.shopify.com/seo-master?utm_source=SEOAnt&utm_medium=seoant_uninstall&utm_campaign=error_page';  // 安装app界面

/** APP Dashboard 首页 模块 */
export const reqGetAppDashboardData = (params) => ajax(API_DOMAIN + '/api/v1/getAppDashboardData', '', 'GET'); // 获取首页Dashboard 数据  [ 页面优化达标数量 ， 最新301跳转链接(5个) ]
// export const reqGoogleConsoleSitemap7Days = (params) => ajax(API_DOMAIN + '/api/v1/getGoogleConsoleSitemap7Days', params, 'GET'); //Dashboard 数据 获取用户的近7天GoogleConsoleSitemap
export const reqHomeAdClick = (params) => ajax(API_DOMAIN + '/api/v2/homeAdClick', params, 'POST'); // 首页广告点击次数


export const reqGetCheckScoreData = (params) => ajax(API_DOMAIN + '/api/v2/seoData', '', 'GET'); // 获取首页Dashboard 检测数据

export const reqReviewTipsClick = (params) => ajax(API_DOMAIN + '/api/v2/reviewTipsClick', params, 'POST'); // 首页评价banner


/** 检测页面 模块 */
// export const reqGetWebsiteCheckData = (params) => ajax(API_DOMAIN + '/api/v1/getWebsiteCheckData', params, 'GET'); // 获取检测页面数据
// export const reqRefreshWebsiteCheck = (params) => ajax(API_DOMAIN + '/api/v1/refreshWebsiteCheck', params, 'POST'); // 重新检查

export const reqGetUserLevel = (params) => ajax(API_DOMAIN + '/api/v1/getUserLevel', params, 'GET'); // 获取用户等级
export const reqGetCleanCode = (params) => ajax(API_DOMAIN + '/api/v1/getCleanCode', params, 'GET'); // 清除代码
export const reqSaveCleanCode = (params) => ajax(API_DOMAIN + '/api/v1/saveCleanCode', params, 'POST'); // 清除代码

// export const reqGetEmptyImageAltList = (params) => ajax(API_DOMAIN + '/api/v1/getEmptyImageAltList', params, 'GET'); // Dashboard 数据  [  获取图片alt为空的列表，根据类型 ]
export const reqGetOptimizeLogs = (params) => ajax(API_DOMAIN + '/api/v1/optimizeLogs', params, 'GET'); // Dashboard 获取批量操作详情
// export const reqPostBulkEditProuctAlt = (params) => ajax(API_DOMAIN + '/api/v1/updateBulkEditProuctAlt', params, 'POST'); //首页快速修改alt
export const reqGetQuickOptimizeStatus = (params) => ajax(API_DOMAIN + '/api/v1/getQuickOptimizeStatus', params, 'GET'); //首页轮询状态并执行发送队列操作
export const reqPostNeedQuickOptimize = (params) => ajax(API_DOMAIN + '/api/v1/updateNeedQuickOptimize', params, 'POST'); //修改是否需要展示首页快速优化状态
export const reqGetOptimizeRecord = (params) => ajax(API_DOMAIN + '/api/v1/getOptimizeRecord', params, 'GET'); // 获取编辑历史记录

// seo checker
export const reqGetSEOCheckerData = (params) => ajax(API_DOMAIN + '/api/v2/seo-checker/getData', params, 'GET');// seo checker检测请求接口
export const reqGetOneKeyFix = (params) => ajax(API_DOMAIN + '/api/v2/seo-checker/getOneKeyFix', params, 'GET');// seo checker弹窗配置
export const reqSetOneKeyFix = (params) => ajaxJSON(API_DOMAIN + '/api/v2/seo-checker/saveOneKeyFix', params, 'POST');// seo checker保存弹窗配置
export const reqRescan = (params) => ajax(API_DOMAIN + '/api/v2/seo-checker/rescan', params, 'GET');// seo checker检测

//PageSpeed 检测
export const reqPageSpeedWebsiteCheck = (params) => ajaxWithoutAuth('https://www.googleapis.com/pagespeedonline/v5/runPagespeed', params, 'GET');//PageSpeed检测请求接口

// 获取谷歌分数检测
export const reqGetPageSpeedOnlineByGoogle = (params) => ajax(API_DOMAIN + '/api/v2/expert-services/getPageSpeedOnlineByGoogle', params, 'GET');


// 登录授权路由接口
// export const reqLogin = (params) => ajax(API_DOMAIN + '/login', params, 'POST');

export const reqPostManualUninstall = (params) => ajax(API_DOMAIN + '/api/v1/manualUninstall', params, 'POST'); // 用户手动卸载APP

export const reqSaveSearchConsoleAuthData = (params) => ajax(API_DOMAIN + '/api/v1/save-search-console-auth-data', params, 'POST'); // 保存Google 授权成功的数据
// export const reqGetSearchConsoleSiteData = (params) => ajax(API_DOMAIN + '/api/v1/get-search-console-site-data', params, 'GET'); // 保存Google 授权成功的数据
export const reqGoogleSearchConsoleAuth = (params) => ajaxWithoutAuth('https://accounts.google.com/o/oauth2/token', params, 'POST'); // Google Search Consoe 授权请求

export const reqJumpOnPageDetail = (params) => ajax(API_DOMAIN + '/api/v2/google-sc/jumpOnPageDetail', params, 'POST'); // 跳转onpage详情
export const reqGoogleAddMyKeyword = (params) => ajax(API_DOMAIN + '/api/v2/google-sc/addMyKeyword', params, 'POST'); // 添加关键词


/** On Page SEO 模块 */
export const reqGetOnPageList = (params) => ajax(API_DOMAIN + '/api/v2/on-page/getOnPageList', params, 'GET'); //获取产品列表
export const reqGetProductIdList = (params) => ajax(API_DOMAIN + '/api/v1/getProductDetail/'+params.id, '', 'GET'); //获取单独产品数据
// export const reqPostProductIdSeo = (params) => ajax(API_DOMAIN + '/api/v1/ProductSeoCheck', params, 'POST'); //获取单独产品数据Seo检测
export const reqPostProductIdAction = (params) => ajax(API_DOMAIN + '/api/v1/productAction', params, 'POST'); //修改单独产品的数据
// export const reqGetProductUseCount = (params) => ajax(API_DOMAIN + '/api/v1/getProductUseCount', params, 'GET'); //获取当前用户 是否免费用户，返回已使用的产品数量
export const reqUpdateHideNotify = (params) => ajax(API_DOMAIN + '/api/v1/hideNotify', params, 'POST'); // 隐藏通知
export const reqCkUpload = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ckUpload', params, 'POST'); // 富文本图片上传
export const reqUpdIgnoreStatus = (params) => ajax(API_DOMAIN + '/api/v2/seo-checker/updIgnoreStatus', params, 'POST'); // onpage操作忽略状态
export const reqAiKeywordSuggestion = (params) => ajax(API_DOMAIN + '/api/v2/ai/keywordSuggestion', params, 'GET'); // ai关键词建议
export const reqGetKeywordSuggestion = (params) => ajax(API_DOMAIN + '/api/v2/keyword-research/keywordSuggestion', params, 'GET'); // 获取关键词建议
export const reqSaveKeyword = (params) => ajax(API_DOMAIN + '/api/v2/on-page/addKeyword', params, 'POST'); // 保存关键词

// export const reqGetCollectionsList = (params) => ajax(API_DOMAIN + '/api/v1/getAllCollections', params, 'GET'); //获取Collections列表
export const reqGetCollectionsIdList = (params) => ajax(API_DOMAIN + '/api/v1/getCollectionDetail/' + params.collectionId + '/' + params.collectionType, '', 'GET'); //获取单独Collections数据
// export const reqPostCollectionsIdSeo = (params) => ajax(API_DOMAIN + '/api/v1/CollectionSeoCheck', params, 'POST'); //获取单独Collections数据Seo检测
export const reqPostCollectionsIdAction = (params) => ajax(API_DOMAIN + '/api/v1/collectionsAction', params, 'POST'); //修改单独Collections的数据

// export const reqGetBlogList = (params) => ajax(API_DOMAIN + '/api/v1/getAllBlog', params, 'GET'); //获取文章列表
export const reqGetBlogIdList = (params) => ajax(API_DOMAIN + '/api/v1/getArticleDetail/' + params.blogId + '/' + params.articleId, '', 'GET'); //获取单独文章数据
// export const reqPostBlogIdSeo = (params) => ajax(API_DOMAIN + '/api/v1/BlogSeoCheck', params, 'POST'); //获取单独文章数据Seo检测
export const reqPostBlogIdAction = (params) => ajax(API_DOMAIN + '/api/v1/blogAction', params, 'POST'); //修改单独文章的数据

// export const reqGetPagesList = (params) => ajax(API_DOMAIN + '/api/v1/getAllPages', params, 'GET'); //获取页面(Page) 列表
export const reqGetEditPageList = (params) => ajax(API_DOMAIN + '/api/v1/getPageDetail/' + params.pageId, '', 'GET'); //获取单独页面(Page) 数据
// export const reqPostEditPageSeo = (params) => ajax(API_DOMAIN + '/api/v1/PagesSeoCheck', params, 'POST'); //获取单独页面(Page) 数据Seo检测
export const reqPostEditPageAction = (params) => ajax(API_DOMAIN + '/api/v1/pagesAction', params, 'POST'); //修改单独页面(Page) 的数据

// export const reqGetSpecialPagesList = (params) => ajax(API_DOMAIN + '/api/v1/getAllSpecialPages', params, 'GET'); //获取页面(special Page) 列表
export const reqGeteditSpecialPageList = (params) => ajax(API_DOMAIN + '/api/v1/getSpecialPageDetail/' + params.pageId, '', 'GET'); //获取单独页面(special Page) 数据
// export const reqPosteditSpecialPageSeo = (params) => ajax(API_DOMAIN + '/api/v1/SpecialPageSeoCheck', params, 'POST'); //获取单独页面(special Page) 数据Seo检测
export const reqPosteditSpecialPageAction = (params) => ajax(API_DOMAIN + '/api/v1/specialPagesAction', params, 'POST'); //修改单独页面(special Page) 的数据

export const reqPostGetSmartKeywordSuggest = (params) => ajax(API_DOMAIN + '/api/v1/getSmartKeyword', params, 'POST'); // 智能关键词推荐 google 抓取
export const reqPostGetSystemSmartKeywordSuggest = (params) => ajax(API_DOMAIN + '/api/v1/getSystemSmartKeyword', params, 'POST'); // 系统关键词推荐
export const reqGetMetaTag = (params) => ajax(API_DOMAIN + '/api/v1/getMetaTag', params, 'GET'); // 系统关键词推荐
export const reqGetMyKeywords = (params) => ajax(API_DOMAIN + '/api/v2/getMyKeywords', params, 'GET'); // 获取个人关键词库数据

export const reqAfreshCheck = (params) => ajax(API_DOMAIN + '/api/v2/on-page/afreshCheck', params, 'POST'); // 点击重新检测
export const reqSetWebsiteData = (params) => ajax(API_DOMAIN + '/api/v2/on-page/setWebsiteData', params, 'POST'); // 接收前端检测源代码
export const reqScanPageContext = (params) => ajax(API_DOMAIN + '/api/v2/on-page/scanPageContext', params, 'POST'); // 页面实时分数检测

export const reqBulkImageNotAlt = (params) => ajax(API_DOMAIN + '/api/v2/on-page/bulkImageNotAlt', params, 'GET'); // 保存alt优化

export const reqBulkProductTag = (params) => ajax(API_DOMAIN + '/api/v2/on-page/bulkProductTag', params, 'POST'); // 批量操作产品tag

/** Bulk Edit  模块 */
export const reqGetBulkEditMetaTags   = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/geBulkEditMetaTags', params, 'GET'); //  自动模板页面: 获取用户保存的配置
// export const reqUpdateBulkEditAutoConfig = (params) => ajax(API_DOMAIN + '/api/v1/updateBulkEditAutoConfig', params, 'POST'); //  自动模板页面: 获取用户保存的配置
// export const reqGetOptimizeStatus = (params) => ajax(API_DOMAIN + '/api/v1/getOptimizeStatus', params, 'GET'); //  轮询优化状态
// export const reqGetManualBulkEditList = (params) => ajax(API_DOMAIN + '/api/v1/getManualBulkEditList', params, 'GET'); //  批量修改页面: 获取列表 (类型有:product/collections/blog/page)
export const reqPostmanualBulkEditAction = (params) => ajax(API_DOMAIN + '/api/v1/manualBulkEditAction', params, 'POST'); //  批量修改页面: 修改处理控制器 (alt)
// export const reqPostUpdateManualBulkEditMetaData = (params) => ajax(API_DOMAIN + '/api/v1/updateManualBulkEditMetaData', params, 'POST'); //  批量修改页面: 顶部统一保存 (meta tag)
// export const reqGetPreviewRecord = (params) => ajax(API_DOMAIN + '/api/v1/getPreviewRecord', params, 'GET'); //  获取更新状态
// export const reqPostUpdateBulkEditAutoPreview = (params) => ajax(API_DOMAIN + '/api/v1/updateBulkEditAutoPreview', params, 'POST'); //  更新页面Google search engine preview
export const reqGetUpdBulkEditPreview = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/updBulkEditPreview', params, 'GET'); //  更新preview预览数据
// export const reqGetOptimizeRecord = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/getOptimizeRecord', params, 'GET'); // 获取编辑历史记录V2

/** HTML Sitemap 模块 */
export const reqGetHtmlSitemapData = (params) => ajax(API_DOMAIN + '/api/v2/html-sitemap/getHtmlSitemapData', params, 'GET'); // 获取Html Sitemap页面数据

/** Structured Data  模块 */
// export const reqGetStructuredData = (params) => ajax(API_DOMAIN + '/api/v1/getStructuredData', params, 'GET'); //  Structured Data: 获取用户配置
export const reqUpdateStructuredData = (params) => ajax(API_DOMAIN + '/api/v1/updateStructuredData', params, 'POST'); //  Structured Data: 用户修改配置
export const reqInsertCreateCampaignImage = (params) => ajax(API_DOMAIN + '/api/v1/InsertCreateCampaignImage', params, 'POST'); // Structured Data: 添加图片
export const reqUpdateJsonLDConfig = (params) => ajax(API_DOMAIN + '/api/v1/updateJsonLDConfig', params, 'POST'); //修改jsonLD 配置  
export const reqUpdateHTMLSitemap = (params) => ajax(API_DOMAIN + '/api/v1/updateHTMLSitemap', params, 'POST'); //修改sitemap 配置  
export const reqCheckPreviewFinish = (params) => ajax(API_DOMAIN + '/api/v1/checkPreviewFinish', params, 'POST'); //检测队列是否跑完

/** Broken Links  模块 */
export const reqGetAllBrokenLinks = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/getAllBrokenLinks/'+params.type, params, 'GET'); //获取Brokent数据
// export const reqGetBatchOperation = (params) => ajax(API_DOMAIN + '/api/v1/getBatchOperation', params, 'POST'); // 获取批量修改表的数据
// export const reqUpdateBatchOperation = (params) => ajax(API_DOMAIN + '/api/v1/updateBatchOperation', params, 'POST'); // 获取批量修改表的数据
export const reqBrokenManageLinkById = (params) => ajax(API_DOMAIN + '/api/v1/deleteBrokenLinkById/' + params.pageId, '', 'GET'); //删除Brokent数据
export const reqPostManageLinkByIdAction = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/updBrokenLinkById', params, 'POST'); //修改Brokent数据
export const reqBrokenIgnoerLinkById = (params) => ajax(API_DOMAIN + '/api/v1/reductionBrokenLinkById/' + params.pageId, '', 'GET'); //还原Ignoer page数据
export const reqBrokenDeleteLinkById = (params) => ajax(API_DOMAIN + '/api/v1/reqBrokenDeleteLinkById/' + params.pageId, '', 'GET'); //还原Ignoer page数据
// export const reqGetDashboardData = (params) => ajax(API_DOMAIN + '/api/v1/getDashboardData', '', 'GET'); // 获取首页Dashboard 数据
// export const reqGetDashboardDataNumber = (params) => ajax(API_DOMAIN + '/api/v1/getDashboardDataNumber', '', 'GET'); // 获取首页Dashboard 的数量数据
// export const reqGetDashboardDataNewest = (params) => ajax(API_DOMAIN + '/api/v1/getDashboardDataNewest', '', 'GET'); // 获取首页dashboard 最新记录数据
// export const reqUpdateBulkEditAutoRedirect = (params) => ajax(API_DOMAIN + '/api/v1/updateBulkEditAutoRedirect', params, 'POST'); // 修改自动批量跳转
export const reqAddBrokenLinkById = (params) => ajax(API_DOMAIN + '/api/v1/addBrokenLinkById', params, 'POST'); //添加单个链接
export const reqImportRedirects = (params) => ajax(API_DOMAIN + '/api/v1/importRedirects', params, 'POST'); //导入Redirects
export const reqExportRedirects = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/export', params, 'POST'); //导出Redirects 
export const reqGetImportRecords = (params) => ajax(API_DOMAIN + '/api/v1/getImportRecords', '', 'GET'); // 获取用户的导入记录
export const reqGetExportRecords = (params) => ajax(API_DOMAIN + '/api/v1/getExportRecords', '', 'GET'); // 获取用户的导出记录
export const reqGetFailedLog = (params) => ajax(API_DOMAIN + '/api/v1/getFailedLog', params, 'POST'); // 获取用户的错误日志
// export const reqGetUserSettingsData = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/getUserEmailData', params, 'GET'); //获取Settings数据
export const reqCheckThemeAppExtension = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/checkThemeAppExtension', params, 'GET'); //获取Settings数据


/** Exchange Backlink 模块 */
export const reqSetBrandName = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/setBrandName', params, 'POST'); //设置brand链接
export const reqToExchange = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/exchange', params, 'POST'); //发起互换链接
export const reqGetIndexData = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/getIndexData', params, 'GET'); //获取互换外链首页基础数据
export const reqGetApplyRecord = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/getApplyRecord', params, 'GET'); //获取互换申请历史记录
export const reqGetPartnerLinkUrl = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/getPageUrl', params, 'GET'); //检测和获取用户外链页面路径
export const reqGetTableScoreRecord = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/getTableScoreRecord', params, 'GET'); //获取表格数据
export const reqCheckWebsite = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/checkWebsite', params, 'GET'); //检测网站
export const reqSetEmail = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/setEmail', params, 'POST'); // 邮件通知
// new linkapi
export const reqGetLinkTableList = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/getTableList', params, 'GET'); //获取互换外链列表数据
export const reqActionChangeLink = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/action', params, 'POST'); // 操作 (批量)
export const reqJumpUrlAction = (params) => ajax(API_DOMAIN + '/api/v2/exchange-backlink/jumpUrl', params, 'POST'); // 请求用户地址



/** 代码控制 模块 */
// export const reqGetCodeListControl = (params) => ajax(API_DOMAIN + '/api/v2/code-control/getCodeList', params, 'GET'); //获取页面数据
// export const reqHandleCodeControl = (params) => ajax(API_DOMAIN + '/api/v2/code-control/handleCode', params, 'POST'); //操作代码开关
// export const reqHandleSwitchControl = (params) => ajax(API_DOMAIN + '/api/v2/code-control/handleSwitch', params, 'POST'); //操作功能开关
// export const reqAfreshCheckControl = (params) => ajax(API_DOMAIN + '/api/v2/code-control/afreshCheck', params, 'GET'); //重新检测




/** Site Audit  模块 */

// export const reqGetSiteAuditData = (params) => ajax(API_DOMAIN + '/api/v1/getSiteAuditData', params, 'GET'); //获取Brokent数据
// export const reqReGetSiteAuditData = (params) => ajax(API_DOMAIN + '/api/v1/reGetSiteAuditData', params, 'GET'); //获取Brokent数据

/** Advanced Settings  模块 */

// export const reqUpdateUserEmailSwitchData = (params) => ajax(API_DOMAIN + '/api/v1/updateUserEmailSwitchData', params, 'POST'); //修改Settings数据
export const reqGoogleConsoleSitemapData = (params) => ajax(API_DOMAIN + '/api/v1/getGoogleConsoleSitemapData', params, 'POST'); //获取GoogleConsoleSitemap数据
export const reqDisconnectGoogleConsoleStatus = (params) => ajax(API_DOMAIN + '/api/v1/disconnectGoogleConsoleStatus', params, 'GET'); //获取GoogleConsoleSitemap数据
export const reqSaveGoogleSitemap = (params) => ajax(API_DOMAIN + '/api/v1/saveGoogleSitemap', params, 'POST'); //提交sitemap文件


/** 新版google search console */
// export const reqConnectGoogleConsole = (params) => ajax(API_DOMAIN + '/api/v1/getConnectGoogleConsole', params, 'POST'); //获取GoogleConsoleSitemap数据

export const reqGetJumpGoogleapisAuth = (params) => ajax(API_DOMAIN + '/api/v2/google-sc/googleapis-auth/getJumpGoogleapisAuth', params, 'GET'); //获取谷歌授权

export const reqGetGoogleAuthTimer = (params) => ajax(API_DOMAIN + '/api/v2/google-sc/getGoogleAuthTimer', params, 'GET'); //定时获取数据

export const reqGoogleConsoleStatus = (params) => ajax(API_DOMAIN + '/api/v2/google-sc/getGoogleConsoleStatus', params, 'GET'); //获取GoogleConsoleSitemap数据


/* ContactUs 联系我们模板 */

export const reqGetThisUserEmail = (params) => ajax(API_DOMAIN + '/api/v1/getThisUserEmail', params, 'GET'); //获取Settings数据
export const reqInsertContactUs = (params) => ajax(API_DOMAIN + '/api/v1/insertContactUs', params, 'POST'); //修改Settings数据
export const reqGetSettingInfo = (params) => ajax(API_DOMAIN + '/api/v1/getSettingInfo', params, 'GET'); //修改Settings数据
export const reqUpdateCustomerClick = (params) => ajax(API_DOMAIN + '/api/v1/updateCustomerClick', params, 'POST'); // 更新客服平台点击信息

/* SEO Expert Services */
export const reqGetSeoExpertService = (params) => ajax(API_DOMAIN + '/api/v1/getSeoExpertService', params, 'GET'); // 获取额外服务信息


// 翻译模块
export const reqGetSelectLanguage = (params) => ajax(API_DOMAIN + '/api/v1/getSelectLanguage', '', 'GET'); // 获取当前选择语言
export const reqUpdateLanguage = (params) => ajax(API_DOMAIN + '/api/v1/updateLanguage', params, 'POST'); // 获取当前选择语言

//PageSpeed App
// export const reqGetAppTrafficRecord = (params) => ajax(API_DOMAIN + '/api/v1/getAppTrafficRecord', params, 'GET'); // 获取PageSpeed App安装记录
// export const reqGetPageSpeedAppAuthor = (params) => ajax(API_DOMAIN + '/api/v1/getPageSpeedAppAuthor', params, 'GET'); // 获取PageSpeed App安装/登录链接

/** PageSpeed接口模块 */
// export const reqCheckPageSpeedAuth = (params) => ajax(API_DOMAIN + '/api/v1/checkPageSpeedAuth', params, 'GET'); // 检测PageSpeed用户是否存在
// export const reqPopImageAlt = (params) => ajax(API_DOMAIN + '/api/v1/PopImageAlt', params, 'GET'); // 邀请用户好评弹窗

// export const reqGetAppSettingData = (params) => {
//     params['interface'] = '/fromSeoAnt/getAppSettingData';
//     return ajax(API_DOMAIN + '/api/v1/getAppSettingData', params, 'GET');
// }; // 获取设置页面数据
// export const reqUpdateAppSettingDataNew = (params) => {
//     params['interface'] = '/fromSeoAnt/updateAppSettingDataNew';
//     return ajax(API_DOMAIN + '/api/v1/updateAppSettingDataNew', params, 'POST');
// }; // 保存设置页面数据
// export const reqGetAppDashboardDataNew = (params) => {
//     params['interface'] = '/fromSeoAnt/getAppDashboardDataNew';
//     return ajax(API_DOMAIN + '/api/v1/getAppDashboardDataNew', params, 'GET');
// }; // 获取图片数据页面
// export const reqGetTabelContent = (params) => {
//     params['interface'] = '/fromSeoAnt/getTabelContent';
//     return ajax(API_DOMAIN + '/api/v1/getTabelContent', params, 'GET');
// }; // 获取首页列表的数据
// export const reqGetTabelAltContent = (params) => {
//     params['interface'] = '/fromSeoAnt/getTabelAltContent';
//     return ajax(API_DOMAIN + '/api/v1/getTabelAltContent', params, 'GET');
// }; // 获取首页列表的数据
// export const reqGetAppImageDataNew = (params) => {
//     params['interface'] = '/fromSeoAnt/getAppImageDataNew';
//     return ajax(API_DOMAIN + '/api/v1/getAppImageDataNew', params, 'GET');
// }; // 获取图片数据页面
// export const reqPostAllRestore = (params) => {
//     params['interface'] = '/fromSeoAnt/postAllRestore';
//     return ajax(API_DOMAIN + '/api/v1/postAllRestore', params, 'POST')
// }; // 全部还原
// export const reqPostReOptimize = (params) => {
//     params['interface'] = '/fromSeoAnt/postReOptimize';
//     return ajax(API_DOMAIN + '/api/v1/postReOptimize', params, 'POST')
// }; // 重新优化
// export const reqGetImageOptimizationDate = (params) => {
//     params['interface'] = '/fromSeoAnt/getImageOptimizationDate';
//     return ajax(API_DOMAIN + '/api/v1/getImageOptimizationDate', params, 'POST')
// }; // 获取当前ID状态
// export const reqEditActionData = (params) => {
//     params['interface'] = '/fromSeoAnt/editActionData';
//     return ajax(API_DOMAIN + '/api/v1/editActionData', params, 'POST')
// }; // 获取图片数据页面
// export const reqGetUserImageCount = (params) => {
//     params['interface'] = '/fromSeoAnt/getUserImageCount';
//     return ajax(API_DOMAIN + '/api/v1/getUserImageCount', params, 'GET')
// }; // 获取最新图片数量跟状态
// export const reqUpdateUserImageCount = (params) => {
//     params['interface'] = '/fromSeoAnt/updateUserImageCount';
//     return ajax(API_DOMAIN + '/api/v1/updateUserImageCount', params, 'POST')
// }; // 请求重新读取数据
// export const reqPostManualSynchronization = (params) => {
//     params['interface'] = '/fromSeoAnt/postManualSynchronization';
//     return ajax(API_DOMAIN + '/api/v1/postManualSynchronization', params, 'POST');
// }; // 手动同步优化
// export const reqUpdateUserTrialCredits = (params) => {
//     params['interface'] = '/fromSeoAnt/updateUserTrialCredits';
//     return ajax(API_DOMAIN + '/api/v1/updateUserTrialCredits', params, 'POST');
// }; // 将额度修改至50
// export const reqUpdateUserFirstOptimize = (params) => {
//     params['interface'] = '/fromSeoAnt/updateUserFirstOptimize';
//     return ajax(API_DOMAIN + '/api/v1/updateUserFirstOptimize', params, 'POST');
// }; // 更新用户是否第一次压缩
// export const reqGetPricingPlans = (params) => {
//     params['interface'] = '/fromSeoAnt/getPricingPlans';
//     return ajax(API_DOMAIN + '/api/v1/getPricingPlans', params, 'GET');
// }; // 获取用户当前套餐，以及所有套餐
// export const reqChangePlans = (params) => {
//     params['interface'] = '/fromSeoAnt/changePlans';
//     return ajax(API_DOMAIN + '/api/v1/changePlans', params, 'POST');
// }; // 获取用户当前套餐，以及所有套餐
// export const reqGetImageSyncStatus = (params) => {
//     params['interface'] = '/fromSeoAnt/getImageSyncStatus';
//     return ajax(API_DOMAIN + '/api/v1/getImageSyncStatus', params, 'GET');
// }; // 保存设置页面数据
// export const reqSubmissionImagesActionUpdate = (params) => {
//     params['interface'] = '/fromSeoAnt/submissionImagesActionUpdate';
//     return ajax(API_DOMAIN + '/api/v1/submissionImagesActionUpdate', params, 'POST')
// }; // 请求重新读取数据

//PageSpeed pay
// export const reqPageSpeedPay = (params) => ajax(API_DOMAIN + '/api/v1/pageSpeedPay', params, 'POST'); // 购买pagespeed服务
export const reqGetPageSpeedPayLog = (params) => ajax(API_DOMAIN + '/api/v1/getPageSpeedPayLog', params, 'GET'); //获取客户技术支持购买服务记录
export const reqGetNewPageSpeedPayLog = (params) => ajax(API_DOMAIN + '/api/v2/expert-services/getPgPayLog', params, 'GET'); //获取新客户技术支持购买服务记录

// 获取套餐信息
export const reqGetPayMeal = (params) => ajax(API_DOMAIN + '/api/v1/getPayMeal', params, 'GET'); //获取客户技术支持购买服务记录

/** PayPal **/
export const reqWalletRecharge = (params) => ajax(API_DOMAIN + '/api/v1/walletRecharge', params, 'POST'); //钱包发起充值

export const reqGetPayPalStatus = (params) => ajax(API_DOMAIN + '/api/v1/getPayPalStatus', params, 'GET'); //获取支付状态

/** Speed Score **/
export const reqPageSpeedOnline=(params) => ajax(API_DOMAIN + '/api/v1/getPageSpeedOnline', params, 'GET'); //获取优化分数
export const reqPostPageSpeedOnline=(params) => ajax(API_DOMAIN + '/api/v1/postPageSpeedOnline', params, 'POST'); //获取优化分数

/** Structured Data  模块 升级2.0 */
//获取开关数据
// export const reqGetLocalBusinessConfig = (params) => ajax(API_DOMAIN + '/api/v1/jsonld/getLocalBusinessConfig', params, 'GET');

// export const reqPostLocalBusinessConfig = (params) => ajax(API_DOMAIN + '/api/v1/jsonld/postLocalBusinessConfig', params, 'POST');
export const reqGetMiddleIntegration = (params) => ajaxMiddleWithoutAuth(MIDDLE_INTEGRATION_API +'/api/v1/middleground/getRecommend', params, 'GET'); // Google Search Consoe 授权请求

/** AMP 模块 **/
export const reqUpdateAMPStatus = (params) => ajax(API_DOMAIN + '/api/v2/amp/updSwitchStatus', params, 'POST'); // 更新AMP各个页面状态
export const reqGetAMPData = (params) => ajax(API_DOMAIN + '/api/v2/amp/getAMPData', params, 'GET'); // 获取AMP各个页面数据
export const reqGetAmpSpeedScoreStatus = (params) => ajax(API_DOMAIN + '/api/v1/getAmpSpeedScoreStatus', params, 'GET'); // 获取AMP分数检测数据
export const reqSaveAMP = (params) => ajax(API_DOMAIN + '/api/v1/saveAMP', params, 'POST'); // 保存AMP设置数据
export const reqUploadImage = (params) => ajax(API_DOMAIN + '/api/v2/amp/uploadImage', params, 'POST'); // 上传AMP图片
export const reqGetImage = (params) => ajax(API_DOMAIN + '/api/v2/amp/getImage', params, 'GEt'); // 获取AMP图片
export const reqRemoveImage = (params) => ajax(API_DOMAIN + '/api/v2/amp/removeImage', params, 'GET'); // 删除AMP图片
export const reqGetGoogleFont = (params) => ajax(API_DOMAIN + '/api/v1/getGoogleFont', params, 'GET'); // 获取Google字体列表
export const reqGenerateAMPPage = (params) => ajax(API_DOMAIN + '/api/v2/amp/updAMPPage', params, 'POST'); // 获取Google字体列表
export const reqSyncAMPImage = (params) => ajax(API_DOMAIN + '/api/v2/amp/syncAMPImage', params, 'GET'); // 获取Google字体列表
export const reqGetSyncAMPImageJob = (params) => ajax(API_DOMAIN + '/api/v1/getSyncAMPImageJob', params, 'GET'); // 获取同步图片队列状态信息
export const reqGetClearAmpStatus = (params) => ajax(API_DOMAIN + '/api/v1/getClearAmpStatus', params, 'GET'); // 获取按钮进度
export const reqGetAMPMoblile = (params) => ajax(API_DOMAIN + '/api/v2/amp/getAppHomeView', params, 'GET'); // 请求Mobile数据
export const reqUpdateAMPMoblile = (params) => ajax(API_DOMAIN + '/api/v2/amp/updAppHomeView', params, 'POST'); // 更新Mobile数据
export const reqUpdateAmpPageStatus = (params) => ajax(API_DOMAIN + '/api/v1/updateAmpPageStatus', params, 'POST'); // 修改amp文件展示状态
export const reqGetAMPBatchOpt = (params) => ajax(API_DOMAIN + '/api/v2/amp/getBatchOpt', params, 'GET'); // 请求批量操作记录
export const reqBtUpdPageStatus = (params) => ajax(API_DOMAIN + '/api/v2/amp/btUpdPageStatus', params, 'POST'); // 批量操作
export const reqGetAMPList = (params) => ajax(API_DOMAIN + '/api/v2/amp/getAMPList', params, 'GET'); // 列表数据
export const reqUpdAMPPageStatus = (params) => ajax(API_DOMAIN + '/api/v2/amp/updAMPPageStatus', params, 'POST'); // 更新状态


/** 升级获取价格方案 **/
// export const reqGetUserPricingPlan = (params) => ajax(API_DOMAIN + '/api/v1/getUserPricingPlan', params, 'GET'); // 获取价格Plan
// export const reqUpdateUserPricingPlanV2 = (params) => ajax(API_DOMAIN + '/api/v1/updateUserPricingPlanV2', params, 'POST'); // 更改价格方案
// export const reqGetUserDiscountPlanByIndex = (params) => ajax(API_DOMAIN + '/api/v1/getUserDiscountPlanByIndex', params, 'GET'); // 获取首页弹窗优惠方案
export const reqPostUserDiscountRecord = (params) => ajax(API_DOMAIN + '/api/v1/postUserDiscountRecord', params, 'POST'); // 提交用户点击折扣记录
export const reqGetCouponByUser = (params) => ajax(API_DOMAIN + '/api/v2/expert-services/getCoupon', params, 'POST'); // 创建优惠券
export const reqGetUserCouponData = (params) => ajax(API_DOMAIN + '/api/v2/expert-services/getUserCouponData', params, 'GET'); // 创建优惠券
export const reqCheckUserCouponCode = (params) => ajax(API_DOMAIN + '/api/v2/expert-services/checkUserCode', params, 'GET'); // 创建优惠券

/** 关键词 **/
export const reqGetCompetitorKeywords = (params) => ajax(API_DOMAIN + '/api/v2/keyword/getKeywordsInfoList', params, 'GET'); // 获取Competitor Keywords Research页面列表
export const reqQueryCompetitorKeywords = (params) => ajax(API_DOMAIN + '/api/v1/selectWebsiteKeywords', params, 'GET'); // 查询Competitor Keywords Research
export const reqGetKeywordsLibrary = (params) => ajax(API_DOMAIN + '/api/v1/getKeywordsLibraryList', params, 'GET'); // 获取Keywords Library页面列表
export const reqHandleKeywords = (params) => ajax(API_DOMAIN + '/api/v1/handleKeywords', params, 'POST'); // 用户操作关键词信息
export const reqHandleOwnKewords = (params) => ajax(API_DOMAIN + '/api/v1/handleOwnKewords', params, 'POST'); // 用户操作自己的关键词信息
// export const reqAddOnPageKeyword = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/addOnPageKeyword', params, 'POST'); // 用户操作自己的关键词信息
export const reqAddOnPageKeyword = (params) => ajax(API_DOMAIN + '/api/v2/keyword/add', params, 'POST'); // 用户操作自己的关键词信息
export const reqHandleKeywordsLibraryList = (params) => ajax(API_DOMAIN + '/api/v1/handleKeywordsLibrary', params, 'POST'); // 用户操作关键词库列表
export const reqQueryCompetitorKeywordsDetail = (params) => ajax(API_DOMAIN + '/api/v1/getKeywordsDetailInfoList', params, 'GET'); // 获取关键词详情
export const reqImportKeywords = (params) => ajax(API_DOMAIN + '/api/v1/importKeywords', params, 'POST'); // 导入关键词url
export const reqAddKeywordsLibrary = (params) => ajax(API_DOMAIN + '/api/v1/addKeywordsLibrary', params, 'POST'); // 用户添加关键词到关键仓库
export const reqGetImportKeywordsLog = (params) => ajax(API_DOMAIN + '/api/v1/getImportKeywordsLog', params, 'GET'); // 获取关键词导入记录
export const reqGetSelectDataList = (params) => ajaxJSON(API_DOMAIN + '/api/v2/keyword/getSelectDataList', params, 'POST'); // 获取所有产品列表
export const reqAddKeywords = (params) => ajaxJSON(API_DOMAIN + '/api/v2/keyword/addKeywords', params, 'POST'); // 添加关键词
// 关键词对比
export const reqGetGapCompetitorList = (params) => ajax(API_DOMAIN + '/api/v2/keywords-comparison/getData', params, 'GET'); // 获取竞争对手关键词数据
export const reqGetGapTableList = (params) => ajax(API_DOMAIN + '/api/v2/keywords-comparison/getTableList', params, 'GET'); // 获取列表数据
// 我的网站关键词
export const reqGetMyWebsiteData = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/getData', params, 'GET'); // 获取数据
export const reqUpdMyWebsiteSwitch = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/updSwitch', params, 'POST'); // 导入关键词url
export const reqGetMyWebsiteTableList = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/getTableList', params, 'GET'); // 获取数据
export const reqAddMyWebsiteKeywordsLibrary = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/addKeywordsLibrary', params, 'POST'); // 收集关键词
export const reqAddMyWebsiteMyKeyword = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/addMyKeyword', params, 'POST'); // 收集关键词
export const reqHandleOnPageKeyword = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/handleOnPageKeyword', params, 'POST'); // 操作关键词
export const reqGetOnPageKeywordList = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/onPageKeywordList', params, 'GET'); // 获取onpage 关键词
// 关键词搜索
export const reqGetGoogleAdsData = (params) => ajax(API_DOMAIN + '/api/v2/keyword-research/google-ads/keyword', params, 'POST'); // 获取数据

// 关键词v2558
export const reqGetKeywordsData = (params) => ajax(API_DOMAIN + '/api/v2/keyword/data', params, 'GET'); // 获取关键词数据
export const reqGetKeywordsListData = (params) => ajax(API_DOMAIN + '/api/v2/keyword/list', params, 'GET'); // 获取关键词列表
export const reqSaveCategory = (params) => ajax(API_DOMAIN + '/api/v2/keyword/saveCategory', params, 'POST'); // 保存关键词分类
export const reqUnlockKeywordsPosition = (params) => ajax(API_DOMAIN + '/api/v2/keyword/unlockPosition', params, 'POST'); // 解锁关键词网站排名
export const reqGetKeywordsWebsite = (params) => ajax(API_DOMAIN + '/api/v2/keyword/website', params, 'GET'); // 获取关键词网站列表数据
export const reqGetExportRecord = (params) => ajax(API_DOMAIN + '/api/v2/keyword/getExportRecord', params, 'GET'); // 获取关键词导出记录
export const reqExportKeywords = (params) => ajax(API_DOMAIN + '/api/v2/keyword/exportKeywords', params, 'POST'); // 导出关键词列表
export const reqAddToKeywordCategory = (params) => ajax(API_DOMAIN + '/api/v2/keyword/addToKeywordCategory', params, 'POST'); // 关键词添加到分类


// 顶部公共数据
export const reqGetHeaderInfo = (params) => ajax(API_DOMAIN + '/api/v1/getHeaderInfo', params, 'GET'); // TopBar是否显示Review

/**通知功能 */
export const reqGetStatisticsMessage = (params) => ajax(API_DOMAIN + '/api/v2/getStatisticsMessage/' + params.type, params, 'GET'); // TopBar通知栏消息内容记录

export const reqUpdateStatisticsMessages = (params) => ajax(API_DOMAIN + '/api/v2/updateStatisticsMessage', params, 'POST'); // TopBar通知栏消息状态修改

export const reqDeleteStatisticsMessages = (params) => ajax(API_DOMAIN + '/api/v2/updateStatisticsMessage', params, 'DELETE'); // TopBar通知栏消息状态删除

export const reqGetMessageTabsInfo = (params) => ajax(API_DOMAIN + '/api/v2/getMessageTabsInfo', params, 'GET'); // TopBar通知栏消息数量信息

// 新手引导
// export const reqUpdNewHand = (params) => ajax(API_DOMAIN + '/api/v1/updNewHand', params, 'POST'); // 修改新手引导步骤状态
// export const reqDelNewHand = (params) => ajax(API_DOMAIN + '/api/v1/delNewHand', params, 'GET'); // 结束新手引导

/*** 价格方案v2高级版 ***/
export const reqGetUserPricingPlanList = (params) => ajax(API_DOMAIN + '/api/v2/getUserPricingPlanList', params, 'GET'); // 获取用户价格方案
export const reqUpdateUserPricingPlan = (params) => ajax(API_DOMAIN + '/api/v2/updateUserPricingPlan', params, 'POST'); // 升级
export const reqPlanConversion = (params) => ajax(API_DOMAIN + '/api/v2/planConversion', params, 'POST'); // 确认转换升级
// 新版价格页套餐版本
export const reqGetNewUserPricingPlanList = (params) => ajax(API_DOMAIN + '/api/v2/pricing/getPricingPlan', params, 'GET'); // 获取用户价格方案
export const reqGetSubscription = (params) => ajax(API_DOMAIN + '/api/v2/pricing/subscription', params, 'POST'); // APP订阅
export const reqGetSubscriptionCancel = (params) => ajax(API_DOMAIN + '/api/v2/pricing/subscriptionCancel', params, 'POST'); // APP订阅取消降级


/*** 客服点击同步按钮 ***/
export const reqSyncOnPageData = (params) => ajax(API_DOMAIN + '/api/v2/syncOnPageData', params, 'GET'); // 确认转换升级

/*** 额度引导好评卡片 ***/
export const reqUserComboByCard = (params) => ajax(API_DOMAIN + '/api/v2/on-page/userComboByCard', params, 'GET');

export const reqCountJumpService = (params) => ajax(API_DOMAIN + '/api/v1/countJumpService', params, 'POST'); // 统计app内部引流专家服务跳转数据


export const reqClickAppNoticeCount = (params) => ajax(API_DOMAIN + '/api/v2/clickAppNoticeCount', params, 'GET'); // 统计app首页点击通知数据

// 用户验证模块
export const reqUserAuthInstall = (params) => ajax(API_DOMAIN + '/shopify/app', params, 'GET'); // 用户验证


// 活动管理模块
// export const reqGetIndexInfoData = (params) => ajax(API_DOMAIN + '/api/v2/activity/getIndexInfoData', params, 'GET'); // 获取活动-首页
export const reqSetShowModalStatus = (params) => ajax(API_DOMAIN + '/api/v2/activity/setShowModalStatus', params, 'GET'); //活动弹窗设置
// export const reqGetActivityServiceData = (params) => ajax(API_DOMAIN + '/api/v2/activity/getActivityServiceData', params, 'GET'); //活动弹窗设置
// export const reqActAppSubscription = (params) => ajax(API_DOMAIN + '/api/v2/activity/appSubscription', params, 'POST'); //app活动订阅接口
export const reqActExpertSubscription = (params) => ajax(API_DOMAIN + '/api/v2/activity/esSubscription', params, 'POST'); //专家服务活动订阅接口

// 界面事件埋点
export const reqAddActionEventLog = (params) => ajax(API_DOMAIN + '/api/v2/activity/addActionEventLog', params, 'POST'); //埋点

// 集成模块
export const reqGetShopifyPrimary = (params) => ajax(API_DOMAIN + '/api/v2/integrations/getShopifyPrimary', params, 'GET'); // 获取集成选择
export const resSaveShopifyPrimary = (params) => ajax(API_DOMAIN + '/api/v2/integrations/saveShopifyPrimary', params, 'POST'); // 设置集成选择

// Canny插件
export const reqGetCannyPlugInSSO = (params) => ajax(API_DOMAIN + '/api/v1/getCannyPlugInSSO', params, 'GET'); // Canny插件接口

// 开发环境 公共数据测试接口
// export const reqGetAppPublicData = (params) => ajax('http://api-app.seoant.run/shopify/app', params, 'GET'); // 公共接口

// 获取首次验证接口（公共+首页）
export const reqGetHomeCommonData = (params) => ajax(API_DOMAIN + '/api/v2/home', params, 'GET');

// 操作指南状态更新
// export const reqUpdateUseGuide = (params) => ajax(API_DOMAIN + '/api/v2/updUseGuide', params, 'GET');

// AI
export const reqGetDataInfo = (params) => ajax(API_DOMAIN + '/api/v2/ai/getDataInfo', params, 'GET'); // 获取产品数据AI
export const reqAiDataInit = (params) => ajax(API_DOMAIN + '/api/v2/ai/init', params, 'GET'); // 店铺初始化AI
export const reqGenerateAi = (params) => ajax(API_DOMAIN + '/api/v2/ai/generate', params, 'POST'); // AI生成内容
export const reqAppApplicationCharge = (params) => ajax(API_DOMAIN + '/api/v2/ai/appApplicationCharge', params, 'POST'); // 购买积分
export const reqGenerateTextAi = (params) => ajax(API_DOMAIN + '/api/v2/ai/optText', params, 'POST'); // AI片段生成内容

/**
 * JDON LD 模块
 */
export const reqGetJsonLdDataV2 = (params) => ajax(API_DOMAIN + '/api/v2/json-ld/getJsonLdData', params, 'GET');
export const reqUpSwitchJsonLdSwitchV2 = (params) => ajax(API_DOMAIN + '/api/v2/json-ld/updateSwitch', params, 'POST');
export const reqSaveJsonLdV2 = (params) => ajax(API_DOMAIN + '/api/v2/json-ld/save', params, 'POST');

// 获取活动改版数据
export const reqGetDiscountAct = (params) => ajax(API_DOMAIN + '/api/v2/getActivityPlan', params, 'GET');

// instant page
export const reqGetInstantPageSwitch = (params) => ajax(API_DOMAIN + '/api/v2/instant-page/getSwitch', params, 'GET');
export const reqSetInstantPageSwitch = (params) => ajax(API_DOMAIN + '/api/v2/instant-page/setSwitch', params, 'GET');

export const reqGetSiteSpeedUp = (params) => ajax(API_DOMAIN + '/api/v2/expert-services/getSiteSpeedUp', params, 'GET'); // 获取speedup状态
export const reqSaveSiteSpeedUp = (params) => ajax(API_DOMAIN + '/api/v2/expert-services/saveSiteSpeedUp', params, 'POST'); // 保存speedup状态

export const reqGetOptDetail = (params) => ajax(API_DOMAIN + '/api/v2/seo-checker/getOptDetail', params, 'GET'); // 获取SEOChecker问题项详细项列表
export const reqUpdOptDetail = (params) => ajax(API_DOMAIN + '/api/v2/seo-checker/updOptDetail', params, 'POST'); // 更新SEOChecker问题项忽略状态
export const reqGetFeedback = (params) => ajax(API_DOMAIN + '/api/v2/feedback/get', params, 'GET'); // 获取Feedback数据
export const reqGetSiteVerify = (params) => ajax(API_DOMAIN + '/api/v2/site-verification/get', params, 'GET'); // 获取网页验证数据
export const reqUpdateSiteVerify = (params) => ajax(API_DOMAIN + '/api/v2/site-verification/upd', params, 'POST'); // 保存网页验证数据

// 缓存状态
export const reqSaveSwitchState = (params) => ajax(API_DOMAIN + '/api/v2/saveAppSwitch', params, 'POST');

// Brokenlink
export const reqUpdAutoRedirect = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/updAutoRedirect', params, 'POST'); // 开关 - 自动重定向
export const reqUpdBatchOpt = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/updBatchOpt', params, 'POST'); // 批量操作
export const reqGetBatchOpt = (params) => ajax(API_DOMAIN + '/api/v2/broken-links/getBatchOpt', params, 'GET'); // 获取批量操作数据
 
// 获取设置信息账户
export const reqGetAccount = (params) => ajax(API_DOMAIN + '/api/v2/setting/account', params, 'GET'); 
// 获取邮箱通知设置
export const reqGetNotification = (params) => ajax(API_DOMAIN + '/api/v2/setting/notification', params, 'GET'); 
// 保存邮箱通知设置
export const reqSetNotification = (params) => ajax(API_DOMAIN + '/api/v2/setting/notification', params, 'POST'); 

// 获取图片压缩统计数据
export const reqGetImgOptTotal = (params) => ajax(API_DOMAIN + '/seo-ant/v2/image-opt/getImgOptTotal', params, 'GET'); // 获取基础数据
export const reqGetProductImagesData = (params) => ajax(API_DOMAIN + '/seo-ant/v2/image-opt/getProductImagesData', params, 'GET'); // 获取图片数据
export const reqGetImageOptDataPage = (params) => ajax(API_DOMAIN + '/seo-ant/v2/image-opt/getImageOptDataPage', params, 'GET'); // 获取图片列表
export const reqGetOptSchedule = (params) => ajax(API_DOMAIN + '/seo-ant/v2/image-opt/getOptSchedule', params, 'GET'); // 获取优化实时数据
export const reqUpdateIsDownload = (params) => ajaxJSON(API_DOMAIN + '/seo-ant/v2/image-opt/updateIsDownload', params, 'POST');  // 更新图片下载状态
export const reqSaveSettings = (params) => ajaxJSON(API_DOMAIN + '/seo-ant/v2/image-opt/saveSettings', params, 'POST');  // 保存设置或开启自动
export const reqUploadImagesOpt = (params) => ajaxJSON(API_DOMAIN + '/seo-ant/v2/image-opt/uploadImagesOpt', params, 'POST');  // 上传图片优化
export const reqBatchRestore = (params) => ajaxJSON(API_DOMAIN + '/seo-ant/v2/image-opt/restore', params, 'POST');  // 批量恢复
export const reqBatchReOptimize = (params) => ajaxJSON(API_DOMAIN + '/seo-ant/v2/image-opt/reOptimize', params, 'POST');  // 批量优化
export const reqStopImageOptTask = (params) => ajax(API_DOMAIN + '/seo-ant/v2/image-opt/stopImageOptTask', params, 'GET');  // 停止优化
export const reqGetAltData = (params) => ajax(API_DOMAIN + '/api/v2/image-alt/altDate', params, 'GET'); // alt数据

// 保存元标签批量规则
export const reqUpdBulkMetaConfig = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/updBulkMetaConfig', params, 'POST'); 
// 获取meta优化记录
export const reqGetRecord = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/getRecord', params, 'GET'); 
// 获取批量优化进度
export const reqGetMetaTagBatchOpt = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/getBatchOpt', params, 'GET'); 
export const reqUpdAloneBulkOpt = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/updAloneOpt', params, 'POST');  // 单个恢复 | 优化
export const reqUpdBatchBulkOpt = (params) => ajax(API_DOMAIN + '/api/v2/meta-tags/updBatchOpt', params, 'POST');  // 批量恢复 | 优化


// onpage小语种翻译切换
export const reqSelectDetailLanguage = (params) => ajax(API_DOMAIN + '/api/v2/on-page/selectLanguage', params, 'GET');  // 小语种翻译切换
export const reqGetTrResources = (params) => ajax(API_DOMAIN + '/api/v2/on-page/getTrResources', params, 'GET');  // 获取语种详细数据
export const reqUpdTranslationsRegister = (params) => ajax(API_DOMAIN + '/api/v2/on-page/updTranslationsRegister', params, 'POST');  // 保存小语种数据
// 价格折扣码
export const reqGetPricingCouponData = (params) => ajax(API_DOMAIN + '/api/v2/pricing/getUserCouponData', params, 'GET');  
// 首页领取折扣
export const reqGetGuideCoupon = (params) => ajax(API_DOMAIN + '/api/v2/pricing/getGuideCoupon', params, 'GET');  

// 获取周期上限扣费记录
export const reqGetUsageRecordList = (params) => ajax(API_DOMAIN + '/seo-ant/v2/image-opt/getUsageRecordList', params, 'GET');  

export const reqGetAppAds = (params) => ajax(ADMIN_DOMAIN + '/open-api/ad/getAppAds', params, 'GET'); // 超管app数据
export const reqAddAdsClickNum = (params) => ajax(ADMIN_DOMAIN + '/open-api/ad/addAdsClickNum', params, 'POST'); // 广告埋点

export const reqSetReCountStatus = (params) => ajax(API_DOMAIN + '/api/v2/setting/setReCountStatus', params, 'POST'); // 设置是否统计访问量状态

// 检测网站状态+密码
export const reqCheckWebStatus = (params) => ajax(API_DOMAIN + '/api/v2/web-check/checkWebStatus', params, 'GET'); // 检测网站状态
export const reqSetPassword = (params) => ajax(API_DOMAIN + '/api/v2/web-check/setPassword', params, 'POST'); // 设置店铺密码

// 外链统计
export const reqGetAuditData = (params) => ajax(API_DOMAIN + '/api/v2/backlink-audit/getData', params, 'GET'); // 获取页面数据
export const reqGetAuditTableList = (params) => ajax(API_DOMAIN + '/api/v2/backlink-audit/getTableList', params, 'GET'); // 获取列表数据
export const reqSetAuditUpdSwitch = (params) => ajax(API_DOMAIN + '/api/v2/backlink-audit/updSwitch', params, 'POST'); // 操作功能开关

// 超额付费上限调整
export const reqUpdExcessLimit = (params) => ajax(API_DOMAIN + '/api/v2/pricing/updExcessLimit', params, 'POST'); 
// seo分析数据
export const reqGetSeoAnalytics = (params) => ajax(API_DOMAIN + '/api/v2/report/seoAnalytics', params, 'GET'); // 获取report数据
// 获取速度优化数据
export const reqGetSpeedupData = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/getData', params, 'GET'); // 获取页面数据
// 搜索url关键词
export const reqSelectOnPageKeyword = (params) => ajax(API_DOMAIN + '/api/v2/my-keywords/selectOnPageKeyword', params, 'POST'); 

// 获取及时索引数据
export const reqGetInstantIndexData = (params) => ajax(API_DOMAIN + '/api/v2/indexing/getData', params, 'GET'); // 获取数据
export const reqUpdIndexSwitch = (params) => ajax(API_DOMAIN + '/api/v2/indexing/updSwitch', params, 'POST');  // 开关
export const reqUploadJsonFile = (params) => ajax(API_DOMAIN + '/api/v2/indexing/uploadJsonFile', params, 'POST');  // 上传json
export const reqSubmitGoogleUrl = (params) => ajax(API_DOMAIN + '/api/v2/indexing/submitUrl', params, 'POST');  // 提交或删除

// 速度优化
export const reqCopyThemeData = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/copyTheme', params, 'GET');  // 获取复制主题
export const reqSpeedUpData = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/speedUpTheme', params, 'GET');  // 获取主题记录
export const reqSpeedUpSetting = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/getSetting', params, 'GET');  // 获取加速设置
export const reqUpSpeedUpSetting = (params) => ajaxJSON(API_DOMAIN + '/api/v2/site-speed-up/updSetting', params, 'POST');  // 更新加速设置
export const reqStartSpeedUp = (params) => ajaxJSON(API_DOMAIN + '/api/v2/site-speed-up/speedUp', params, 'POST');  // 发起优化
export const reqGetSpeedupRecord = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/getRecord', params, 'GET');  // 获取优化记录
export const reqActionThemeData = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/actionTheme', params, 'POST');  // 发布和重置主题
export const reqRestartSpeedUp = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/restartSpeedUp', params, 'POST');  // 重新发起优化
export const reqCloseSucPubBanner = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/closeBanner', params, 'POST');  // 关闭恢复banner
export const reqRefreshPageOnline = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/refreshPageSpeedOnline', params, 'POST');  // 刷新分数数据
export const reqGetPageSpeedOnlineStatus = (params) => ajax(API_DOMAIN + '/api/v2/site-speed-up/getPageSpeedOnlineStatus', params, 'GET');  // 获取刷新状态


// Ai OnPage
export const reqGetAiBlogProductList = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/getProductList', params, 'GET'); // 获取产品列表
export const reqUpdBulkAiKeyword = (params) => ajax(API_DOMAIN + '/api/v2/ai/bulkAiKeyword', params, 'POST'); // ai批量生成关键词
export const reqGetTopicKeywords = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/getTopicKeywords', params, 'GET'); // 获取话题和主题关键词
export const reqGetCompetitorWebData = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/getCompetitorWebData', params, 'GET'); // 获取竞争网站数据 
export const reqGetAdsKeywordList = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/getAdsKeywordList', params, 'GET'); // 获取关键词谷歌搜索数据 
export const reqGetArticleTitleList = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/getArticleTitleList', params, 'GET'); // 获取标题列表 
export const reqGenerateArticle = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/generateArticle', params, 'POST'); // ai生成博客文章  
export const reqGetGenerateArticle = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/getGenerateArticle', params, 'GET'); // 获取最新生成文章记录 
export const reqSaveGBSetting = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/saveSetting', params, 'POST'); // 保存设置
export const reqCreateAiBlogArticle = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/createArticle', params, 'POST'); // 创建博客文章
export const reqPublishAiBlogArticle = (params) => ajax(API_DOMAIN + '/api/v2/on-page/ai-blog/publishArticle', params, 'POST'); // 发布博客文章
export const reqGetBulkAIKeywordProgress = (params) => ajax(API_DOMAIN + '/api/v2/ai/getBulkAIKeywordProgress', params, 'GET'); // 获取关键词状态

// Ai 超额
export const reqHandleAIUsagePayment = (params) => ajax(API_DOMAIN + '/api/v2/pricing/handleAIUsagePayment', params, 'GET'); // ai超额

export const reqDelCache = (params) => ajax(API_DOMAIN + '/api/v2/delCache', params, 'POST');  // 清除缓存
